import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { NewsletterState, SubscriberApiResponse } from './types';
import { fetchSubscribers } from './actions';

const initialState: NewsletterState = {
  subscribers: [],
  totalCount: 0,
  loading: 'idle',
  error: null,
};

const newsletterSlice = createSlice({
  name: 'newsletter',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSubscribers.pending, (state) => {
        state.loading = 'pending';
        state.error = null;
      })
      .addCase(fetchSubscribers.fulfilled, (state, action: PayloadAction<SubscriberApiResponse>) => {        
        state.loading = 'succeeded';
        state.subscribers = action.payload.data;
        state.totalCount = action.payload.total;
      })
      .addCase(fetchSubscribers.rejected, (state, action) => {
        state.loading = 'failed';
        state.error = (action.payload as any)?.message || 'Failed to fetch subscribers';
      });
  },
});

export default newsletterSlice.reducer;
